"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.visuallyHiddenStyles = exports.selectedItemStyles = exports.hoveredItemStyles = void 0;

var _styledComponents = require("styled-components");

var _tokens = _interopRequireDefault(require("@paprika/tokens"));

var hoveredItemStyles = (0, _styledComponents.css)(["background-color:", ";font-weight:bold;"], _tokens["default"].color.blackLighten70);
exports.hoveredItemStyles = hoveredItemStyles;
var selectedItemStyles = (0, _styledComponents.css)(["background-color:#cde5fc;font-weight:bold;"]);
exports.selectedItemStyles = selectedItemStyles;
var visuallyHiddenStyles = (0, _styledComponents.css)(["height:0;overflow:hidden;width:0;"]);
exports.visuallyHiddenStyles = visuallyHiddenStyles;
//# sourceMappingURL=shared.styles.js.map